<template>
  <v-avatar
    v-if="transport === 'seq'"
    :size="iconSize"
    color="#09234B"
    class="pa-1"
  >
    <svg
      class="svg-icon"
      aria-hidden="true"
    >
      <use xlink:href="#iconhaizhenkuai" />
    </svg>
  </v-avatar>
  <v-avatar
    v-else-if="transport === 'se'"
    :size="iconSize"
    color="green"
    class="pa-1"
  >
    <i
      class="iconfont iconchuan white--text"
      style="font-size: 12px;"
    />
  </v-avatar>
  <v-avatar
    v-else-if="transport === 'se-economy'"
    :size="iconSize"
    color="amber"
    class="pa-1"
  >
    <i
      class="iconfont iconchuan white--text"
      style="font-size: 12px;"
    />
  </v-avatar>
  <v-avatar
    v-else-if="transport === 'se-bizeco'"
    :size="iconSize"
    color="orange"
    class="pa-1"
  >
    <i
      class="iconfont iconchuan white--text"
      style="font-size: 12px;"
    />
  </v-avatar>
  <v-avatar
    v-else-if="transport === 'se-tbpdd'"
    :size="iconSize"
    class="pa-0"
  >
    <img
      src="/static/images/icon/tbpdd-rate.png"
      alt="淘拼專線"
      class="tbpddRateIcon"
    >
  </v-avatar>
  <v-avatar
    v-else-if="transport === 'air'"
    :size="iconSize"
    :color="srType=='twt'?'#f44336':'#2196f3'"
    class="pa-1"
  >
    <i
      class="iconfont iconfeiji1 white--text"
      style="font-size: 12px;"
    />
  </v-avatar>
  <v-avatar
    v-else-if="transport === 'sea'"
    :size="iconSize"
    color="sea-color"
    class="pa-1"
  >
    <i
      class="iconfont iconsea white--text"
      style="font-size: 12px;"
    />
  </v-avatar>
  <!-- <v-avatar
    v-else-if="transport === 'air'"
    :size="iconSize"
    color="red"
    class="pa-1">
    <i
      class="iconfont iconfeiji1 white--text"
      style="font-size: 12px;"/>
  </v-avatar> -->
  <span
    v-else
    :class="[transport + ' ' + srType,small?'small': '']"
    class="srIcon"
  >
    <i
      v-if="transport === 'air'"
      class="iconfont iconfeiji1"
    />
    <i
      v-if="transport === 'se'"
      class="iconfont iconchuan"
    />
    <svg
      v-if="transport === 'seq'"
      class="svg-icon"
      aria-hidden="true"
    >
      <use xlink:href="#iconhaizhenkuai" />
    </svg>
    <i
      v-if="transport === 'sea'"
      class="iconfont iconsea sea-color--text"
    />
  </span>
</template>
<script>
export default {
  props: {
    transport: String,
    srType: String,
    small: Boolean,
    size: [String, Number],
  },
  computed: {
    // 根据尺寸参数返回图标展示大小。
    iconSize () {
      return this.size || (this.small ? 18 : 24)
    },
  },
}
</script>
<style lang="postcss" scoped>
.tbpddRateIcon {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.srIcon {
  border-radius: 50%;
  width: 24px;
  line-height: 24px;
  display: inline-block;
  text-align: center;
  &.small {
    width: 18px;
    line-height: 18px;
    i {
      font-size: 14px;
    }
  }
  &.air {
    color: #2196f3!important;
    background: rgb(33, 150, 243, 0.22);
    &.twt {
      color: #f44336!important;
      background: rgba(244, 67, 54, 0.22);
    }
  }
  &.se {
    color: #4CAF50;
    background: rgba(76, 175, 80, 0.22);
  }
  &.seq {
    background: #09234B;
  }
  &.sea {
    background: rgb(103 68 167 / 20%);
  }
}
</style>
